module.exports = __webpack_public_path__ + "static/media/1.aa2ed699.svg";